import SvgIcon from "@mui/material/SvgIcon";
import { keyframes } from "@mui/system";

const bellSwing = keyframes`
  0% { 
    transform: rotate(0deg); 
    transform-origin: 50% 0%; 
  }
  15% { 
    transform: rotate(12deg); 
    transform-origin: 50% 0%; 
  }
  45% { 
    transform: rotate(-12deg); 
    transform-origin: 50% 0%; 
  }
  60% { 
    transform: rotate(0deg); 
    transform-origin: 50% 0%; 
  }
  100% { 
    transform: rotate(0deg); 
    transform-origin: 50% 0%; 
  }
`;

export const NotificationsIcon = ({ animate = false }) => {
  const getAnimation = () => {
    if (!animate) return {};

    const animations = {
      swing: {
        animation: `${bellSwing} 2s ease-in-out infinite`,
      },
    };

    return animations.swing;
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: "24px",
        height: "24px",
        fill: "none",
        ...getAnimation(),
      }}
      viewBox="0 0 24 24"
    >
      <path
        d="M12.02 2.91c-3.31 0-6 2.69-6 6v2.89c0 .61-.26 1.54-.57 2.06L4.3 15.77c-.71 1.18-.22 2.49 1.08 2.93 4.31 1.44 8.96 1.44 13.27 0 1.21-.4 1.74-1.83 1.08-2.93l-1.15-1.91c-.3-.52-.56-1.45-.56-2.06V8.91c0-3.3-2.7-6-6-6Z"
        stroke="#292D32"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M13.87 3.2a6.75 6.75 0 0 0-3.7 0c.29-.74 1.01-1.26 1.85-1.26s1.56.52 1.85 1.26"
        stroke="#292D32"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.02 19.06c0 1.65-1.35 3-3 3-.82 0-1.58-.34-2.12-.88a3 3 0 0 1-.88-2.12"
        stroke="#292D32"
        strokeWidth={1.5}
        strokeMiterlimit={10}
      />
    </SvgIcon>
  );
};
